import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import HighlightOffOutlined from '@mui/icons-material/HighlightOffOutlined';

interface ParticipantFeatureProps {
  enabled: boolean;
  label: string;
  enabledText?: string;
  disabledText?: string;
  disabledColor?: string;
  disabledBorderColor?: string;
  disabledIconColor?: 'disabled' | 'error' | 'success';
  successColor?: string;
  successBorderColor?: string;
  successIconColor?: 'disabled' | 'error' | 'success';
}

function ParticipantFeature({
  enabled = true,
  label,
  enabledText = 'Yes',
  disabledText = 'No',
  disabledColor = 'grey.100',
  disabledBorderColor = 'grey.300',
  disabledIconColor = 'disabled',
  successColor = 'success.lighter',
  successBorderColor = 'success.light',
  successIconColor = 'success',
}: ParticipantFeatureProps) {
  const Icon = enabled ? CheckCircleOutlined : HighlightOffOutlined;

  return (
    <Box
      sx={{
        textAlign: 'center',
        p: 1.5,
        borderRadius: 2,
        bgcolor: enabled ? successColor : disabledColor,
        border: 1,
        borderColor: enabled ? successBorderColor : disabledBorderColor,
        minWidth: 90,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          mx: 'auto',
          mb: 1,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.paper',
        }}
      >
        <Icon
          color={enabled ? successIconColor : disabledIconColor}
          sx={{
            fontSize: 30,
            display: 'block',
          }}
        />
      </Box>

      <Typography
        variant="subtitle2"
        component="p"
        sx={{
          fontWeight: 700,
          lineHeight: 1.2,
        }}
      >
        {label}
      </Typography>

      <Typography variant="caption" component="p" color="text.secondary" sx={{ mt: 0.25 }}>
        {enabled ? enabledText : disabledText}
      </Typography>
    </Box>
  );
}

export default ParticipantFeature;
